import { endOfDay, startOfDay } from 'date-fns';
import { DateRangeCalendar, getActiveQuickRangeId, type QuickRangeId } from 'common/components';
import { DASHBOARD_QUICK_RANGE_OPTIONS } from '../../dashboardDateRange.utils';

export type DashboardDateRangeChange = {
    startDate: Date;
    endDate: Date;
    quickRangeId: QuickRangeId | null;
};

type DashboardDateRangeSelectorProps = {
    startDate: Date;
    endDate: Date;
    onChange: (change: DashboardDateRangeChange) => void;
};

export const DashboardDateRangeSelector = ({ startDate, endDate, onChange }: DashboardDateRangeSelectorProps) => {
    const maxDate = new Date();

    return (
        <DateRangeCalendar
            startDate={startDate}
            endDate={endDate}
            monthsShown={2}
            position='left'
            aria-label='Date range'
            quickRangeOptions={DASHBOARD_QUICK_RANGE_OPTIONS}
            datePickerProps={{ maxDate }}
            onApply={({ startDate: appliedStart, endDate: appliedEnd }) => {
                const normalizedStart = startOfDay(appliedStart);
                const normalizedEnd = endOfDay(appliedEnd);
                const calendarEnd = startOfDay(appliedEnd);

                const quickRangeId = getActiveQuickRangeId(
                    normalizedStart,
                    calendarEnd,
                    maxDate,
                    maxDate,
                    DASHBOARD_QUICK_RANGE_OPTIONS
                );

                onChange({
                    startDate: normalizedStart,
                    endDate: normalizedEnd,
                    quickRangeId,
                });
            }}
        />
    );
};
